module.exports = __webpack_public_path__ + "img/my-call-me-emperor.14c1aee.png";